/**
 * 　(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 　CONFIDENTIAL / 社外秘
 * 　無断開示・無断複製禁止
 */
<template>
<tr class="tr-td-control">
	<!-- 単体選択 -->
	<td class="td-dataname">
		<div v-if="r_settings.edit_right && r_is_require" class="layout-right">
			<font class="text-red">＊</font>
		</div>
		<div class="layout-left"><!-- 空白除けコメントアウト
			-->{{r_title}}
		</div>
	</td>
	<td class="td-data">
		<div v-if="r_settings.edit_right">
			<el-form onsubmit="return false;"  class="text_code_area" :model="m_disp_text" :rules="m_validationText" ref="valid_target">
				<el-form-item prop="disp_text" class="text_code left-select" >
					<c-inputedit
						style="width: 80%; display: inline-block;"
						class="detail-item-default"
						:r_input_class="createEditClassType(m_disp_text.disp_text)+text_disabled_class"
						r_type="read-only"
						v-model="m_disp_text.disp_text"
					></c-inputedit>
					<c-butsearchinfo
						style="display: inline-block;"
						ref="b_company"
						:r_butName="r_messages.select_btn"
						:r_dialogTitle="r_dialogTitle"
						:r_disabled="r_disabled">
						<!-- 単一選択画面 -->
						<c-wndselectone
							:r_type="r_type"
							:r_param="r_param"
							:r_info="m_objValue"
							:r_messages="r_messages"
							:r_settings="r_settings"
							:r_code="r_code"
							:r_is_no_setting="r_is_no_setting"
							:r_is_model_dependent="r_is_model_dependent"
							@event_change="onChangeDepartments"
						>
						</c-wndselectone>
					</c-butsearchinfo>
				</el-form-item>
				<el-form-item v-if="r_second_btn" prop="disp_text2" class="text_code right-select" >
					<c-inputedit
						style="width: 80%; display: inline-block;"
						class="detail-item-default"
						:r_input_class="createEditClassType2(m_disp_text.disp_text2)+text_disabled_class"
						r_type="read-only"
						v-model="m_disp_text.disp_text2"
					></c-inputedit>
					<c-butsearchinfo
						style="display: inline-block;"
						ref="b_group"
						:r_butName="r_messages.select_btn"
						:r_dialogTitle="r_dialogTitle2"
						:r_disabled="disp_btn2">
						<!-- 単一選択画面 -->
						<c-wndselectone
							:r_type="r_type2"
							:r_param="r_param2"
							:r_info="m_objValue2"
							:r_messages="r_messages"
							:r_settings="r_settings"
							:r_code="r_code2"
							:r_is_no_setting="r_is_no_setting"
							:r_is_model_dependent="r_is_model_dependent"
							@event_change="onChangeDepartments2"
						>
						</c-wndselectone>
					</c-butsearchinfo>
				</el-form-item>
			</el-form >
		</div>
		<div class="div-area" v-else ><!-- 空白除けコメントアウト
		-->{{m_disp_text.disp_text}}<br><!-- 空白除けコメントアウト
		-->{{m_disp_text.disp_text2}}
		</div>
	</td>
</tr>
</template>
<script>
	/**
	 * 詳細画面パーツ.<br>
	 * 呼び出しコード.<br>
	 * @module js\parts\DetailItemCode
	 * @example
	 * <c-edititemcode
	 * 	:r_messages = "r_messages"
	 * 	:r_settings = "r_settings"
	 * 	:info="m_info"
	 * 	@event_close="onClose"
	 * 	@event_btn_copy="onBtnCopy"
	 * >
	 * </c-edititemcode>
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_messages - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {object} info - 編集するデータ
	 * @param {bool} r_disp = {btn_copy:true,btn_freenumsearch:true} - ボタンを表示するか、しないか
	 **/
	 export default {
		props:{
			'r_title':{
				type:String,
				default:""
			},
			'r_dialogTitle':{
				type:String,
				default:""
			},
			'r_dialogTitle2':{
				type:String,
				default:""
			},
			'r_messages':{},
			'r_settings':{},
			'r_param':{},
			'r_param2':{},
			'r_code':[Number,String],
			'r_code2':[Number,String],
			'r_type':[Number,String],
			'r_type2':[Number,String],
			'r_is_no_setting':{
				type:Boolean,
				default:false
			},
			'r_is_model_dependent':{
				type:Boolean,
				default:false
			},
			'r_disp_text':{
				type:String,
				default:""
			},
			'r_disp_text2':{
				type:String,
				default:""
			},
			'r_code_name':{
				type:String,
				default:"text_code"
			},
			'r_code_name2':{
				type:String,
				default:"text_code"
			},
			'r_disp_name':{
				type:String,
				default:"disp_text"
			},
			'r_disp_name2':{
				type:String,
				default:"disp_text"
			},
			'r_disabled':{
				type:Boolean,
				default:false
			},
			'r_second_btn':{
				type:Boolean,
				default:true
			},
			'r_disp_text_data_processing':{
				type:String,
				default:""
			},
		},
		mixins: [
			require('js/common/Edit.mixin.vue'),
			require('js/common/trEdit.mixin.vue'),
			// バリデーションミックスイン
			require('js/common/validate/common.mixin.vue'),
			require('js/common/validate/edit.mixin.vue'),
		],
		data:function (){
			var target = this;
			return{
				m_objValue: {} ,
				m_objValue2:{} ,
				m_disp_text: {disp_text:this.r_disp_text, disp_text2:this.r_disp_text2},
				m_validationText:{
					disp_text: [
						{ required: this.r_is_require, message: this.r_messages.required,trigger:'no' },
						{
							validator: (rule, value, callback) => {
								var errMessage = "";
								var fnValidate = (target.r_validator)?target.r_validator:target.validateType;
								var type = target.CHKTYPE_TEXT;

								errMessage += fnValidate(type,
														value);

								if ( errMessage.length > 0 ) {
									callback(new Error(errMessage));
								} else {
									callback();
								}

							},
							trigger: ''
						}
					],
					disp_text2: [
						{ required: this.r_is_require, message: this.r_messages.required,trigger:'no' },
						{
							validator: (rule, value, callback) => {
								var errMessage = "";
								var fnValidate = (target.r_validator)?target.r_validator:target.validateType;
								var type = target.CHKTYPE_TEXT;

								errMessage += fnValidate(type,
														value);

								if ( errMessage.length > 0 ) {
									callback(new Error(errMessage));
								} else {
									callback();
								}

							},
							trigger: ''
						}
					],
				},
				m_isChange2:false,
			};
		},
		created: function() {
			this.m_objValue = {"text_code:": this.r_code};
			this.m_objValue2 = {"text_code:": this.r_code2};
			if(this.r_disp_text_data_processing != ""){
				this.m_disp_text.disp_text = this.r_disp_text_data_processing;
			}
		},
		/**
		 * @instance
		 **/
		computed: {
			disp_btn2: function () {
				if ( this.r_code ) return false;
				return true;
			},
			text_disabled_class:function(){
				if ( this.r_disabled ) return ' disabled-text';
				return '';
			}
		},
		watch: {
			r_code: function () {
				this.m_objValue = {"text_code:": this.r_code};
			},
			r_code2: function () {
				this.m_objValue2 = {"text_code:": this.r_code2};
			},
			r_disp_text: function (newValue) {
				this.m_disp_text.disp_text = this.r_disp_text;
				if(this.r_disp_text_data_processing != ""){
					this.m_disp_text.disp_text = this.r_disp_text_data_processing;
				}
			},
			r_disp_text2: function (newValue) {
				this.m_disp_text.disp_text2 = this.r_disp_text2;
			},
			r_is_require: function(a, b){
				this.m_validationText.disp_text[0].required = a;
			},
		},
		methods: {
			setUpdate: function(is){
				this.m_isChange = is;
			},
			setUpdate2: function(is){
				this.m_isChange2 = is;
			},
			// trEdit.mixin.vueのものを使わずオーバーライド
			// オーバーライド
			checkUpdate: function(){
				// 編集権限なしの場合は変更なしとする
				if ( !this.r_settings.edit_right ) {
					return false;
				}
				return this.m_isChange || this.m_isChange2;
			},
			/**
			 * コピー元データ取得イベント <br>
			 * ******* 内部処理 *******<br>
			 * event_btn_copyでイベントを受け取り、親にevent_btn_copyイベントを投げる。 <br>
			 *
			 * @function  event_btn_copy
			 * @param {object} info - 元データ
			 * @param {object} copyInfo - コピー元データ
			 * @instance
			 */
			onChangeDepartments: function(info){
				this.$refs.b_company.onButClose();
				this.m_objValue = info;
				this.$emit('update:r_code', info[this.r_code_name]);
				this.$emit('update:r_disp_text', info[this.r_disp_name]);
				this.m_isChange = true;
			},
			onChangeDepartments2: function(info){
				this.$refs.b_group.onButClose();
				this.m_objValue2 = info;
				this.$emit('update:r_code2', info[this.r_code_name2]);
				this.$emit('update:r_disp_text2', info[this.r_disp_name2]);
				this.m_isChange2 = true;
			},
		/**
		* 編集可能箇所のCSSclassを取得する <br>
		* ******* 内部処理 *******<br>
		* フラグを変更する。 <br>
		*
		* @function createEditClassType
		* @param {}
		* @instance
		**/
		createEditClassType2: function(val, isChange = this.m_isChange2){
			var className = this.r_class + " ";
			if( this.r_is_require && val === "" ) {
				// 必須項目で未入力の場合
				className += this.REQUIRED_EMPTY_COL;
				this.m_isNotInput = true;
			} else if ( isChange ) {
				// 編集中
				className += this.UPDATING_COL;
				this.m_isNotInput = false;
			}
			return className;
		},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/TR/editCharger.vue